export default {
  savedTitle: 'Guardar recurso',
  subTitle: 'Organízalo como desees',
  addFolder: 'Crear carpeta',
  cancel: 'Cancelar',
  createFolder: 'Crear',
  inputPlaceholder: 'Ingresar nombre para tu carpeta',
  save: 'Guardar cambios',
  createdByMe: 'Creadas por mí',
  sharedWithMe: 'Compartidas conmigo',
  noFolders: 'Todavía no tienes carpetas, presiona Crear Carpeta para armar una',
  invalidNameFolder: 'Ya haz utilizado ese nombre, prueba con otro.',
  maxLengthError: 'El nombre debe tener como máximo 50 caracteres.',
  toast: {
    button: 'CERRAR',
    message: 'Cambios guardados'
  },
  folderName: 'Nombre de carpeta',
  noEditPermissions: 'No tienes permiso de edición'
}

export const en = {
  // TODO: Check English translations for the add resource modal.
  savedTitle: 'Save resource',
  subTitle: 'Organize it as you wish',
  addFolder: 'Create folder',
  cancel: 'Cancel',
  createFolder: 'Create',
  inputPlaceholder: 'Enter a name for your folder',
  save: 'Save changes',
  createdByMe: 'Created by me',
  sharedWithMe: 'Shared with me',
  noFolders: 'You don\'t have any folders yet, click on Create Folder to create one',
  invalidNameFolder: 'You have already used that name, try another one.',
  maxLengthError: 'The name must have a maximum of 50 characters.',
  toast: {
    button: 'CLOSE',
    message: 'Changes saved'
  },
  folderName: 'Folder name',
  noEditPermissions: 'You don\'t have editing permission'
}

export const ca = {
  savedTitle: 'Desar el recurs',
  subTitle: 'Organitza-ho com vulguis',
  addFolder: 'Crea carpeta',
  cancel: 'Cancel·la',
  createFolder: 'Crea',
  inputPlaceholder: 'Introdueix un nom per a la teva carpeta',
  save: 'Desa els canvis',
  createdByMe: 'Creades per mi',
  sharedWithMe: 'Compartides amb mi',
  noFolders: 'Encara no tens carpetes, fes clic a «Crea Carpeta» per crear-ne una',
  invalidNameFolder: 'Ja s\'ha fet servir aquest nom, prova un altre.',
  maxLengthError: 'El nom ha de tenir un màxim de 50 caràcters.',
  toast: {
    button: 'TANCA',
    message: 'Canvis desats'
  },
  folderName: 'Nom de carpeta',
  noEditPermissions: 'No tens permís d\'edició'
}
